/**
 * Subscription cancel page - shown when user cancels Stripe Checkout
 * Provides options to retry or return to pricing
 */

// No React import needed
import { useNavigate, useSearchParams } from 'react-router-dom';

export function SubscriptionCancelPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get('session_id');

  const handleRetry = () => {
    navigate('/pricing');
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleContactSupport = () => {
    navigate('/contact');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
          {/* Cancel Icon */}
          <div className="mb-6">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 dark:bg-yellow-900/20">
              <svg
                className="h-8 w-8 text-yellow-600 dark:text-yellow-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
          </div>

          {/* Cancel Message */}
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Checkout cancelled
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
            You have not been charged.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={handleRetry} className="btn-primary">
              Try Again
            </button>
            <button onClick={handleGoToDashboard} className="btn-secondary">
              Go to Dashboard
            </button>
          </div>

          {/* Additional Information */}
          <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Have questions?
              <button
                onClick={handleContactSupport}
                className="ml-1 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium"
              >
                Contact Support
              </button>
            </p>
            {sessionId && (
              <p className="text-xs text-gray-400 dark:text-gray-500 mt-2">
                Session ID: {sessionId}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
